
const globalStore = {
  namespaced: true,
  state: {
    activeTabbar: 'mine', // 启动以后默认展示的tabbar
    updateAppDialog: false, // 是否显示更新App弹框
    haveAuthenticed: '', // 是否已实名
    AppVersion: '', // 当前App版本
    maxFilesize: 100 * 1024 * 1024,
    maxImagesize: 10 * 1024 * 1024,
    maxVideosize: 100 * 1024 * 1024,
    ratio: null, // 分辨率
    locationState: window.localStorage.getItem('locationState') || '', // 定位是否开启
    cameraState: window.localStorage.getItem('cameraState') || '', // 相机是否开启
    audioState: window.localStorage.getItem('audioState') || '', // 录音是否开启
    storageState: window.localStorage.getItem('storageState') || '', // 存储及相册是否开启
    photoState: window.localStorage.getItem('photoState') || '', // 存储及相册是否开启
    deviceModel: window.localStorage.getItem('deviceModel') || '', // 设备型号
    deviceId: window.localStorage.getItem('deviceId') || '', // 设备ID
    sourcechannel: window.localStorage.getItem('sourcechannel') || '',
    channel: window.localStorage.getItem('channel') || ''
  },
  mutations: {
    SET_ACTIVETABBAR: (state, activeTabbar) => {
      state.activeTabbar = activeTabbar
    },
    SET_UPDATEAOODIALOG: (state, bool) => {
      state.updateAppDialog = bool
    },
    SET_HAVEAUTHENTICED: (state, bool) => {
      state.haveAuthenticed = bool
    },
    SET_APPVERSION: (state, AppVersion) => {
      state.AppVersion = AppVersion
    },
    SET_RATIO: (state, ratio) => {
      state.ratio = ratio
    },
    SET_LOCATIONSTATE: (state, data) => {
      window.localStorage.setItem('locationState', data)
      state.locationState = data
    },
    SET_CAMERASTATE: (state, data) => {
      window.localStorage.setItem('cameraState', data)
      state.cameraState = data
    },
    SET_AUDIOSTATE: (state, data) => {
      window.localStorage.setItem('audioState', data)
      state.audioState = data
    },
    SET_STORAGESTATE: (state, data) => {
      window.localStorage.setItem('storageState', data)
      state.storageState = data
    },
    SET_PHOTOSTATE: (state, data) => {
      window.localStorage.setItem('photoState', data)
      state.photoState = data
    },
    SET_SOURCECHANNEL: (state, data) => {
      window.localStorage.setItem('sourcechannel', data)
      state.sourcechannel = data
    },
    SET_CHANNEL: (state, data) => {
      window.localStorage.setItem('channel', data)
      state.channel = data
    },
    SET_DEVICEMODEL: (state, data) => {
      window.localStorage.setItem('deviceModel', data)
      state.deviceModel = data
    },
    SET_DEVICEID: (state, data) => {
      window.localStorage.setItem('deviceId', data)
      state.deviceId = data
    }
  },
  actions: {
  }
}

export default globalStore



// WEBPACK FOOTER //
// ./src/views/globalStore.js